module.exports = __webpack_public_path__ + "img/Bahnhof_Oravita_4kl.c408cca5.jpg";